import React from 'react'

import { Box, Typography } from '@mui/material'

import { useLanguage } from '../../i18n'

const Branch = () => {
  const { t } = useLanguage()
  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" fontWeight={700}>
          {t('Branch management')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('Dynamic role system · granular facility & sensor scoping · currently 8 active users')}
        </Typography>
      </Box>
    </Box>
  )
}

export default Branch
